import React, { useState } from 'react';
import { FilterState } from '../../Filters';
import { ExportsService } from '../../../../../services/applicant_tracking/analytics/PipelinePerformanceService/ExportsService';
import { triggerDownload } from '../../../../../utils/triggerDownload';
import { ExportModal as BaseExportModal } from '../../../../../components/ExportModal';
import { momentToDateStr } from '../../../../../utils/momentToDateStr';

interface PropTypes {
  isOpen: boolean;
  filterState: FilterState;
  onCancel: () => void;
}

const EXPORT_OPTIONS = [
  { value: 'PDF', label: 'PDF (*.pdf)' },
  { value: 'CSV', label: 'CSV (*.csv)' },
];

export function ExportModal(props: PropTypes) {
  const [selectedOption, setSelectedOption] = useState(EXPORT_OPTIONS[0]);

  async function handleDownload() {
    const start = momentToDateStr(props.filterState.dateRange.start);
    const end = momentToDateStr(props.filterState.dateRange.end);
    const fileName = `pipeline_performance_report_${start}_${end}`;

    if (selectedOption.value === 'CSV') {
      const blob = await ExportsService.csv(props.filterState);
      triggerDownload(blob, `${fileName}.csv`);
    } else if (selectedOption.value === 'PDF') {
      const blob = await ExportsService.pdf(props.filterState);
      triggerDownload(blob, `${fileName}.pdf`);
    }
  }

  return (
    <BaseExportModal
      isOpen={props.isOpen}
      selected={selectedOption}
      options={EXPORT_OPTIONS}
      onSelect={(newOption) => setSelectedOption(newOption)}
      onDownload={handleDownload}
      onCancel={props.onCancel}
    />
  );
}
